import { PromptTourType } from '@ps/web-core-store';
import produce from 'immer';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

export function usePromptTourActions() {
  const { localSettings } = useDispatch<Dispatch>();
  const userSeenPrompt = useSelector(select.localSettings.getCashier)?.userSeenPrompt;

  const updateUserTour = (flow: PromptTourType) => {
    localSettings.set({
      cashier: {
        userSeenPrompt: produce(
          userSeenPrompt || {},
          (draft: Partial<Record<PromptTourType, boolean>>) => {
            if (flow === PromptTourType.Cashier) {
              draft.firstDeposit = true;
              draft.firstWithdraw = true;
              draft.cashier = true;
            } else {
              draft[flow] = true;
            }
          }
        )
      }
    });
  };

  return updateUserTour;
}
